module.exports = __webpack_public_path__ + "images/accents/accent-peek-preview@2x-3f2eb5dc952d6792196f1bb275dcaf9f.webp";